export const WARRCHIRP_APP_URL = process.env.REACT_APP_WARRCHIRP_APP_URL;
export const WARRBOTS_APP_URL = process.env.REACT_APP_WARRBOTS_APP_URL;
export const WARRINVOICE_APP_URL = process.env.REACT_APP_WARRINVOICE_APP_URL;
export const WARRQUEUE_APP_URL = process.env.REACT_APP_WARRQUEUE_APP_URL;
export const WARRINSIGHTS_APP_URL = process.env.REACT_APP_WARRINSIGHTS_APP_URL;
export const WARRCHIRP_EXPERIENCE_API_URL = process.env.REACT_APP_WARRCHIRP_EXPERIENCE_API_URL;
export const COGNITO_URL = process.env.REACT_APP_COGNITO_URL;
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
